import { render } from "./candidates-kanban-modal.vue?vue&type=template&id=b1c2ddb6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__